import React, {Component} from 'react';

import axios from 'axios'
import Config from '../../Helpers/Config';
import {locale} from '../../locale/AppLocale';
import Loader from '../Loader'
import {NotificationManager} from '../../Helpers/NotificationManager';

export default class Uploader extends Component {

    constructor(props) {
        super(props)
        this.state = {
            uploading: false,
        };
        this.upload = this.upload.bind(this)
    }

    render() {
        return (
            <div className="products-bulk-upload">
                <h1>{locale.get('product_bulk_upload_heading')}</h1>
                <p>{locale.get('product_bulk_upload_desc')}</p>
                <button className="btn-2" disabled={this.state.uploading}>
                    <input type="file" onChange={this.upload} style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                        opacity: 0
                    }}/>
                    <Loader completed={this.state.uploading === false}/>
                    {
                        this.state.uploading === false && locale.get('product_bulk_upload_button')
                    }
                    {
                        this.state.uploading === true && locale.get('product_bulk_uploading_now')
                    }
                </button>

                <div className="bulk-uploader--desc">
                    {locale.get('download_bulk_samples')}
                     <a href="/samples/sample.zip" className="btn-1 btn--small" style={{marginRight:10,minWidth:'auto',padding:'5px 10px',direction:"ltr"}}>.zip</a>
                    <a href="/samples/sample.xlsx" className="btn-1 btn--small" style={{marginRight:10,minWidth:'auto',padding:'5px 10px'}}>excel</a>
                </div>
            </div>
        );
    }


    upload(e) {

        if(e.target.files.length === 0){
            return false;
        }

        if(!this.validateFile(e.target.files[0])){
            NotificationManager.error(locale.get('bulk_upload_invalid_extension'));
            return ;
        }

        this.setState({
            uploading: true
        });

        const formData = new FormData();

        formData.append('file',e.target.files[0]);

        axios.post(Config.api(`products/bulk-upload/${this.props.businessId}`), formData, {
            withCredentials: Config.withCredentials()
        }).then((response) => {
            this.setState({
                uploading: false
            });
            this.props.onUpload(response.data);

        }).catch((error) => {
            if (error.response.status === 401) {
                this.props.requiresReLogin();
            } else {
                if(error.response && error.response.data && error.response.data.message){
                    NotificationManager.error(error.response.data.message);
                }
            }
            this.setState({uploading: false});
        });
    }


    validateFile(file) {

        const validExtensions = ['csv','zip','xls','xlsx'];

        const fileExt = file.name.split('.').pop().toLowerCase();

        return validExtensions.includes(fileExt)
    }
}